"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiSkeleton = getMuiSkeleton;
function getMuiSkeleton(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      pulse: {
        backgroundColor: palette.grey[300]
      },
      root: {
        backgroundColor: palette.grey.A700,
        borderRadius: '6px',
        opacity: '8%'
      },
      wave: {
        backgroundColor: palette.grey[300]
      }
    }
  };
}